import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { approveParticipantAudio, approveParticipantVideo, rejectCascadeAudioRoomMuted, rejectCascadeVideoRoomMuted, rejectParticipantAudioRoomMuted, rejectParticipantAudioRoomUnMuted, rejectParticipantVideoRoomMuted, rejectParticipantVideoRoomUnMuted } from '../../../av-moderation/actions';
import Button from '../../../base/ui/components/web/Button';
import { QUICK_ACTION_BUTTON } from '../../constants.any';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
import { getParticipantById } from '../../../base/participants';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            marginRight: theme.spacing(2)
        },
        buttonCustom: {
            // border: "1px solid #EE0033",
            // color: theme.palette.primary10,
            borderRadius: '6px',
            backgroundColor: "#fff",
            height: "32px !important",
            padding: "6px 6px !important",
            width: "auto",
            '&:hover': {
                backgroundColor: "#fff !important"
            }
        }
    };
});
const ParticipantQuickAction = ({ buttonType, muteAudio, participantID, participantName, stopVideo }) => {
    const { classes: styles } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { roomConfiguration } = useSelector((state) => state["features/av-moderation"]);
    const state = APP.store.getState();
    const participantInfo = getParticipantById(state, participantID);
    const askToUnmute = useCallback(() => {
        dispatch(approveParticipantAudio(participantID));
    }, [dispatch, participantID]);
    const allowVideo = useCallback(() => {
        dispatch(approveParticipantVideo(participantID));
    }, [dispatch, participantID]);
    const handleMuteMedia = (id, type) => {
        try {
            console.log('ssadsasd');
            if (type === 'audio') {
                if (roomConfiguration['audio'])
                    dispatch(rejectParticipantAudioRoomMuted(id));
                else {
                    dispatch(rejectParticipantAudioRoomUnMuted(id));
                }
            }
            if (type === 'media') {
                if (roomConfiguration['media'])
                    dispatch(rejectParticipantVideoRoomMuted(id));
                else {
                    dispatch(rejectParticipantVideoRoomUnMuted(id));
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    const muteAudioCustom = (isCasCade) => {
        try {
            if (isCasCade) {
                dispatch(rejectCascadeAudioRoomMuted(participantID));
            }
            else {
                handleMuteMedia(participantID, "audio");
            }
        }
        catch (error) {
            console.log(error, 1);
        }
    };
    const muteVideoCustom = (isCasCade) => {
        try {
            if (isCasCade) {
                dispatch(rejectCascadeVideoRoomMuted(participantID));
            }
            else {
                handleMuteMedia(participantID, "media");
            }
        }
        catch (error) {
            console.log(error, 1);
        }
    };
    const askToUnmuteCustom = useCallback(() => {
        // dispatch(approveParticipant(participantID));
        dispatch(approveParticipantAudio(participantID));
    }, [dispatch, participantID]);
    const askToUnmuteVideoCustom = useCallback(() => {
        // dispatch(approveParticipant(participantID));
        dispatch(approveParticipantVideo(participantID));
    }, [dispatch, participantID]);
    const askUnmuteText = t("participantsPane.actions.askUnmute2");
    const muteParticipantButtonText = t("dialog.mutemicro");
    const muteCascadeButtonText = t("dialog.turnOffMicro");
    const turnOnMicro = t("participantsPane.actions.askUnmute3");
    const askUnmuteVideoText = t("participantsPane.actions.askUnmuteVideo");
    const muteParticipantVideoButtonText = t("dialog.mutecam");
    const muteCascadeVideoButtonText = t("dialog.turnOffCam");
    const turnOnCamera = t("participantsPane.actions.askUnmuteVideo2");
    switch (buttonType) {
        case QUICK_ACTION_BUTTON.MUTE: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.mute')} ${participantName}`, className: styles.buttonCustom, label: (participantInfo?.isCasCade || participantInfo?.isSip) ? muteCascadeButtonText : muteParticipantButtonText, onClick: () => { muteAudioCustom(participantInfo?.isCasCade || participantInfo?.isSip); }, size: 'small', type: BUTTON_TYPES.SECONDARY, testId: `mute-audio-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.ASK_TO_UNMUTE: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.askUnmute')} ${participantName}`, className: styles.buttonCustom, label: (participantInfo?.isCasCade || participantInfo?.isSip) ? turnOnMicro : askUnmuteText, onClick: askToUnmuteCustom, size: 'small', type: BUTTON_TYPES.SECONDARY, testId: `unmute-audio-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.ALLOW_VIDEO: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.askUnmute')} ${participantName}`, className: styles.buttonCustom, label: (participantInfo?.isCasCade || participantInfo?.isSip) ? turnOnCamera : askUnmuteVideoText, onClick: askToUnmuteVideoCustom, size: 'small', type: BUTTON_TYPES.SECONDARY, testId: `unmute-video-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.STOP_VIDEO: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.mute')} ${participantName}`, className: styles.buttonCustom, label: (participantInfo?.isCasCade || participantInfo?.isSip) ? muteCascadeVideoButtonText : muteParticipantVideoButtonText, onClick: () => { muteVideoCustom(participantInfo?.isCasCade); }, size: 'small', type: BUTTON_TYPES.SECONDARY, testId: `mute-video-${participantID}` }));
        }
        default: {
            return null;
        }
    }
};
export default ParticipantQuickAction;
